var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import { body } from "../../../typography";
import { classnames } from "../../../utils";
var DialogContentStyle = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  margin: 0 25px;\n"], ["\n  ", ";\n  margin: 0 25px;\n"])), body);
var DialogContent = function (_a) {
    var className = _a.className, children = _a.children;
    return (React.createElement(DialogContentStyle, { className: classnames("bn-dialog-content", className) }, children));
};
export default DialogContent;
var templateObject_1;
//# sourceMappingURL=DialogContent.js.map